import { render, staticRenderFns } from "./YourAdvisor.vue?vue&type=template&id=315f5c52&scoped=true&"
import script from "./YourAdvisor.vue?vue&type=script&lang=js&"
export * from "./YourAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f5c52",
  null
  
)

export default component.exports